import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'app/components/Button';
import BlueprintSelector from 'app/components/BlueprintSelector';
import type { MatchPreviewData } from 'app/components/MatchPreview/types';

import style from './style.scss';

interface Props {
  match: MatchPreviewData;
  updating: boolean;
  onSelectBlueprint: (id: number) => void;
  onBook: () => void;
  onCreateMarkets: () => void;
}

const MatchActionTrader: FC<Props> = ({
  match,
  updating,
  onSelectBlueprint,
  onBook,
  onCreateMarkets
}) => {
  const [t] = useTranslation();
  const { betting_metadata } = match;

  if (!betting_metadata || (!betting_metadata.booked && betting_metadata.bookable)) {
    return (
      <Button className={style.button} loading={updating} onClick={onBook}>
        {t('events-match_book')}
      </Button>
    );
  }

  if (betting_metadata.booked && !betting_metadata.blueprint && !betting_metadata.markets_created) {
    return (
      <BlueprintSelector
        videogameSlug={match.videogame.slug}
        disabled={updating}
        onChange={onSelectBlueprint}
      />
    );
  }

  if (betting_metadata.booked && betting_metadata.blueprint && !betting_metadata.markets_created) {
    return (
      <Button className={style.button} loading={updating} onClick={onCreateMarkets}>
        {t('events-match_create_markets')}
      </Button>
    );
  }

  return null;
};

MatchActionTrader.displayName = 'MatchActionTrader';

export default MatchActionTrader;
